import type { ReactNode } from "react";
import { Container, Stack, Surface } from "@/components/layout";
import { Text } from "@/components/typography";
import { EmptyState } from "@/components/ui";

export interface ErrorLayoutProps {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function ErrorLayout({
  title = "Something went wrong",
  description = "The page could not be loaded. Your work was not confirmed as completed.",
  action,
}: ErrorLayoutProps) {
  return (
    <Container size="narrow">
      <Stack gap={24} style={{ paddingBlock: "var(--space-36)" }}>
        <Surface>
          <EmptyState
            title={title}
            description={description}
            {...(action ? { action } : {})}
          />
        </Surface>
        <Text role="caption" color="muted" as="p">
          Errors preserve entered work when safe and never imply an uncommitted
          material action succeeded.
        </Text>
      </Stack>
    </Container>
  );
}
